module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-space-between align-center footer"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/home.svg"),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CommunityMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/search.svg"),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'DiscoverMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/trending.svg"),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'SpotlightMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/chat.svg"),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'NotificationMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/user.svg"),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'YouMobile'
        })
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-442020bf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/components/footer.vue
// module id = 1703
// module chunks = 180